<template>
    <div :class="[
        'form__orgunits_item',
        dragModeActive ? `dragactive` : '',
        dragStart ? 'dragstart' : '',
        dragEnter ? 'dragenter' : '',
        !unitChildren.length ? 'form__orgunits_item--nochildren' : '',
        includedInSearchQuery ? 'form__orgunits_item--insearchquery' : '',
        disabled ? 'form__orgunits_item--disabled' : '',
        disabled && !unitId ? 'is-hidden' : ''
    ]">
        <div class="form__orgunits_item_block">
            <div class="form__orgunits_item_block_box">
                <div class="form__orgunits_item_block_box_top">
                    <div class="form__orgunits_item_block_dragcover"></div>
                    <div class="columns fullheight is-vcentered is-variable is-0">
                        <template v-if="!disabled">
                            <div class="column is-narrow">
                                <div class="form__orgunits_item_block_box_top_left">
                                    <div class="columns fullheight">
                                        <div class="column is-narrow">
                                            <div class="form__orgunits_item_block_box_top_left_dragdrop">
                                                <component-button
                                                    v-show="!unitChildren.length"
                                                    :disabled="!allowEdit || disabled"
                                                    :class="'form__orgunits_item_block_box_top_left_dragdrop_button'"
                                                    :name="`form-orgunits-block-box-top-left-dragdrop-button-${index.join('-')}`"
                                                    :icon="true"
                                                    :icon-name="'more-vertical'"
                                                    :icon-raw="true"
                                                    :icon-duplicate="true"
                                                    :fullheight="true"
                                                    :theme="''"
                                                    :draggable="!disabled"
                                                ></component-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="column">
                            <div class="form__orgunits_item_block_box_top_right">
                                <div class="form__orgunits_item_block_box_top_right_details">
                                    <div class="columns is-vcentered">
                                        <template v-if="unitChildren.length && !disabled">
                                            <div class="column is-narrow">
                                                <div class="form__orgunits_item_block_box_top_right_toggle">
                                                    <component-button
                                                        :class="'form__orgunits_item_block_box_top_right_toggle_button'"
                                                        :name="`form-orgunits-block-box-top-right-toggle-button-${index}`"
                                                        :icon="true"
                                                        :icon-name="isMainBoxActive ? 'chevron-down' : 'chevron-right'"
                                                        :icon-raw="true"
                                                        :theme="''"
                                                        @click="switchMainBox"
                                                    ></component-button>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="column">
                                            <div class="form__orgunits_item_block_box_top_right_label">
                                                <template v-if="unitName && !isNameEditable">
                                                    <div
                                                        class="form__orgunits_item_block_box_top_right_label_name"
                                                        @click="enableNameEditable"
                                                    ><span>{{ unitName }}</span></div>
                                                </template>
                                                <template v-else>
                                                    <form-text
                                                        :label="''"
                                                        :name="`form-orgunits-block-box-top-right-field-name-${index.join('-')}`"
                                                        :key="`form-orgunits-block-box-top-right-field-name-${index.join('-')}`"
                                                        :placeholder="'Name'"
                                                        :v-validate="{ required: true, excluded: excludedNamesOutput }"
                                                        :data-vv-as="'name'"
                                                        :value="unitName"
                                                        :hint-button="true"
                                                        @input="setUnitName"
                                                        @emit-hint="performSaveUnitName"
                                                    >Save unit name
                                                    </form-text>
                                                </template>

                                            </div>
                                        </div>
                                        <template v-if="!disabled">
                                            <div class="column is-narrow">
                                                <component-button
                                                    :disabled="disabled || isAnyEditable"
                                                    :name="`form-orgunits-block-box-top-add-${index}`"
                                                    :icon="true"
                                                    :icon-name="'plus-circle'"
                                                    :theme="'default'"
                                                    :text="true"
                                                    :size="'tiny'"
                                                    @click="handleAddNewUnit"
                                                >{{ addUnitText }}
                                                </component-button>
                                            </div>
                                        </template>
                                        <div class="column is-narrow">
                                            <div class="form__orgunits_item_block_box_top_right_dots">
                                                <component-button-menu
                                                    :name="`form-orgunits-block-box-top-dots-button-${index}`"
                                                    :icon-name="'more-horizontal'"
                                                    :theme="'default'"
                                                    :buttons="dotsButtonMenuList"
                                                    :disabled="!allowEdit"
                                                    @emit-remove="openNotifyRemoveUnit"
                                                    @emit-view-users="performRedirectToUsers"
                                                    @emit-edit-managers="enableManagersEditable"
                                                />
                                            </div>
                                        </div>
                                        <template v-if="isNameEditable">
                                            <div class="column is-narrow">
                                                <component-button
                                                    :name="`form-orgunits-block-box-top-cancel-${index}`"
                                                    :icon="true"
                                                    :icon-name="'x'"
                                                    :theme="'default'"
                                                    v-on="unitId ? { 'click': disableNameEditable } : { 'click': emitRemove }"
                                                ></component-button>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="form__orgunits_item_block_box_top_right_managers">
                                    <div class="columns is-vcentered">
                                        <div class="column is-narrow">
                                            <component-text :size="'small'">Managers:</component-text>
                                        </div>
                                        <div class="column">
                                            <template v-if="unitManagers.length">
                                                <div class="form__orgunits_item_block_box_top_right_managers_list">
                                                    <component-text-button
                                                        v-for="(manager, index) in unitManagers"
                                                        :index="index"
                                                        :key="index"
                                                        :value="manager.userProfileId"
                                                        :disabled="disabled"
                                                        @click="openNotifyRemoveManager"
                                                    >{{ manager.firstName }} {{ manager.lastName}}
                                                    </component-text-button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <component-text :size="'small'">none</component-text>
                                            </template>
                                        </div>
                                        <div class="column is-narrow">
                                            <component-button
                                                :disabled="disabled || isAnyEditable"
                                                :name="`form-orgunits-block-box-top-add-manager-${index}`"
                                                :icon="true"
                                                :icon-name="'plus-circle'"
                                                :theme="'default'"
                                                :text="true"
                                                :size="'tiny'"
                                                @click="openNotifyAddManager"
                                            >Add manager
                                            </component-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="isMainBoxActive" class="form__orgunits_item_block_box_main">
                    <div class="form__orgunits_item_block_box_main_form">
                        <form-orgunits
                            :disabled="disabled"
                            :org-units="unitChildren"
                            :index="index"
                            :search-query="searchQuery"
                            @emit-add="emitAdd"
                            @emit-remove="emitRemove"
                            @emit-move="emitMove"
                        ></form-orgunits>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="notifyaddmanager"
            :title-text="'Add manager'"
            :content-text="''"
            :cancel-button-text="'Close'"
            :submit-button-text="'Submit'"
            :submit-button-active="!managerProfileRoles.includes('user_administrator') && !managerProfileIsMA"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'add-manager'"
            :prevent-close="true"
            @emit-submit="performSaveUnitManager"
        >
            <form-select
                :get-pagination-getter="'getLmsSuperadminWorkspaceUsersPagination'"
                :get-items-getter="'getLmsSuperadminWorkspaceUsersMappedIdNameRoles'"
                :get-items-getter-mapped="'getLmsSuperadminWorkspaceUsersMappedLabelValue'"
                :get-items-dispatch="'lmsSuperadminWorkspaceUsersGet'"
                :get-items-dispatch-params="`&status=active&roles=learner,trainer&exactRoles=true`"
                :item-name="['user', 'users']"
                :label="''"
                :name="`form-orgunits-block-box-top-right-field-managers-${index.join('-')}`"
                :search-queryable="true"
                :table-labels="[
                    {
                        key: 'name',
                        title: 'Name',
                        type: 'string',
                        sortable: true,
                        queryable: true
                    }
                ]"
                :value="managerProfileId"
                :advanced-search-active="false"
                @input="setManagerValue"
                @input-table="setManagerValue"
            ></form-select>
            <component-note v-if="managerProfileRoles.includes('user_administrator') || managerProfileIsMA">User already has administrative rights so they cannot be an Organisation unit manager</component-note>
        </pop-notify>
        <pop-notify
            :class="'pop__notify--remove'"
            ref="notifyremoveunit"
            :title-text="'Remove unit'"
            :content-text="'Are you sure want to remove this unit?'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Confirm'"
            :submit-button-danger="true"
            @emit-submit="emitRemove"
        />
        <pop-notify
            :class="'pop__notify--removemanager'"
            ref="notifyremovemanager"
            :title-text="'Remove manager'"
            :content-text="'Are you sure want to remove this manager?'"
            :cancel-button-text="'Cancel'"
            :submit-button-text="'Confirm'"
            :submit-button-danger="true"
            :prevent-close="true"
            @emit-submit="performRemoveUnitManager"
        />
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import FormText from '@/components/default/forms/FormText'
import PopNotify from '@/components/default/shared/PopNotify'
import { toLowerCase } from '@/functions'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentTextButton from '@/components/default/shared/ComponentTextButton'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'form-orgunits-item',
  components: {
    ComponentNote,
    ComponentText,
    ComponentTitle,
    ComponentTextButton,
    FormSelect,
    FormOrgunits: () => import('@/components/default/forms/FormOrgUnits'),
    PopNotify,
    FormText,
    ComponentButtonMenu,
    ComponentButton
  },
  data () {
    return {
      isMainBoxActive: true,
      isNameEditable: false,
      dragStart: false,
      dragEnter: false,
      isManagersEditable: false,
      managerProfileId: '',
      managerProfileRoles: '',
      managerProfileIsMA: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: Array,
      default: () => [0]
    },
    dragModeActive: {
      type: Boolean,
      default: false
    },
    dragItemId: {
      type: String,
      default: ''
    },
    isAnyEditable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    excludedNames: {
      type: Array,
      default: () => []
    },
    searchQuery: {
      type: String
    }
  },
  computed: {
    excludedNamesOutput () {
      let excludedNamesArr = JSON.parse(JSON.stringify(this.excludedNames))
      let indexOfCurrentName = excludedNamesArr.findIndex(obj => obj === this.unitName)

      excludedNamesArr.splice(indexOfCurrentName, 1)

      return excludedNamesArr
    },
    includedInSearchQuery () {
      return this.unitName ? toLowerCase(this.unitName).includes(toLowerCase(this.searchQuery)) : false
    },
    allowEdit () {
      return !this.isAnyEditable
    },
    unitId () {
      return this.item.id
    },
    unitName () {
      return this.item.name
    },
    unitManagers () {
      return this.item.managers || []
    },
    unitParentId () {
      return this.item.parentId
    },
    parentWorkspaceId () {
      return this.$store.getters.getLmsSuperadminOrgUnitsWorkspaceId
    },
    unitChildren () {
      return this.item.children
    },
    //
    addUnitText () {
      let number = Number(this.index.length + 1)
      let numberSuffix

      switch (number) {
        case 2:
          numberSuffix = 'nd'
          break
        case 3:
          numberSuffix = 'rd'
          break
        default:
          numberSuffix = 'th'
          break
      }

      return number + numberSuffix + ' level'
    },
    dotsButtonMenuList () {
      let menuArr = []

      if (!this.disabled) {
        menuArr.push({
          key: 'remove',
          name: 'Remove'
        })
      }
      menuArr.push({
        key: 'view-users',
        name: 'View users'
      })

      return menuArr
    }
  },
  methods: {
    openNotifyRemoveUnit () {
      this.$refs.notifyremoveunit.openNotify()
    },
    openNotifyRemoveManager (data) {
      this.$refs.notifyremovemanager.setStoreValue(data)
      this.$refs.notifyremovemanager.openNotify()
    },
    openNotifyAddManager () {
      this.setManagerValue({ value: '', roles: [], isMasterAdministrator: false })
      this.$refs.notifyaddmanager.openNotify()
    },
    performRedirectToUsers () {
      this.$router.push({ name: 'lms-superadmin-user-list', query: { orgUnits: `${this.unitId};${this.unitName}` } })
    },
    handleAddNewUnit (data) {
      this.$eventBus.$emit('form-org-units-close-specific-group', this.index)
      this.$eventBus.$emit('form-org-units-open-specific-group', this.index)
      this.emitAdd(data)
    },
    enableMainBox (data) {
      if (data) {
        if (data.length === this.index.length) {
          this.isMainBoxActive = true
        }
      } else {
        this.isMainBoxActive = true
      }
    },
    disableMainBox (data) {
      if (data) {
        if ((data.length + 1) === this.index.length) {
          this.isMainBoxActive = false
        }
      } else {
        this.isMainBoxActive = false
      }
    },
    switchMainBox () {
      this.isMainBoxActive = !this.isMainBoxActive
    },
    //
    setUnitName (value) {
      this.$store.dispatch('lmsSuperadminOrgUnitsSetValue', { key: 'name', value: value, index: this.index })
    },
    setUnitManagers (value) {
      this.$store.dispatch('lmsSuperadminOrgUnitsSetValue', { key: 'managers', value: value, index: this.index })
    },
    setManagerValue (value) {
      this.managerProfileId = value ? value.value : ''
      this.managerProfileRoles = value ? value.roles : []
      this.managerProfileIsMA = value ? value.isMasterAdministrator : false
    },
    performSaveUnitName () {
      let dispatchName = 'lmsSuperadminOrgUnitUpdate'
      let dispatchParameters = { id: this.unitId, name: this.unitName, parentId: this.unitParentId, workspaceId: this.parentWorkspaceId }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isRequestPending = true
          this.$store.dispatch(dispatchName, dispatchParameters).finally(() => {
            this.disableNameEditable()
            this.isRequestPending = false
            this.$eventBus.$emit('form-org-units-rerender')
          })
        }
      })
    },
    performSaveUnitManager () {
      let dispatchName = 'lmsSuperadminOrgUnitAddManager'
      let dispatchParameters = { unitId: this.unitId, profileId: this.managerProfileId }

      this.isRequestPending = true
      this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
        const responseManagers = response.managers
        this.setManagerValue('')
        this.setUnitManagers(responseManagers)
        this.$refs.notifyaddmanager.closeNotify()
      }).finally(() => {
        this.isRequestPending = false
        this.$eventBus.$emit('stop-add-manager')
      })
    },
    performRemoveUnitManager () {
      const value = this.$refs.notifyremovemanager.storeValue
      let dispatchName = 'lmsSuperadminOrgUnitRemoveManager'
      let dispatchParameters = { unitId: this.unitId, profileId: value }

      this.isRequestPending = true
      this.$store.dispatch(dispatchName, dispatchParameters).then(response => {
        const responseManagers = response.managers
        this.setUnitManagers(responseManagers)
        this.$refs.notifyremovemanager.closeNotify()
      }).finally(() => {
        this.isRequestPending = false
      })
    },
    emitAdd (data) {
      this.$emit('emit-add', data || this.index)
    },
    emitRemove (data) {
      this.$emit('emit-remove', data || { index: this.index, id: this.unitId, workspaceId: this.parentWorkspaceId })
    },
    emitMove (data) {
      this.$emit('emit-move', data)
    },
    //
    enableManagersEditable () {
      if (!this.isAnyEditable) {
        this.$eventBus.$emit('form-org-units-enable-managers-editable')
        this.isManagersEditable = true
      }
    },
    disableManagersEditable () {
      this.$eventBus.$emit('form-org-units-disable-managers-editable')
      this.isManagersEditable = false
    },
    enableNameEditable () {
      if (!this.isAnyEditable && !this.disabled) {
        this.$eventBus.$emit('form-org-units-enable-name-editable')
        this.isNameEditable = true
      }
    },
    disableNameEditable () {
      this.$eventBus.$emit('form-org-units-disable-name-editable')
      this.isNameEditable = false
    },
    initializeEditableFields () {
      if (this.unitId === '' || this.unitId === undefined) {
        this.enableNameEditable()
      }
    },
    handleDragStart (event) {
      this.$eventBus.$emit('form-org-units-dragstart', this.unitId)
      this.dragStart = true
    },
    handleDragEnter (event) {
      this.$eventBus.$emit('form-org-units-disable-dragenter')
      setTimeout(() => {
        this.dragEnter = true
      }, 1)
    },
    handleDragLeave (event) {
      this.dragEnter = false
    },
    handleDragEnd (event) {
      this.$eventBus.$emit('form-org-units-dragend')
      this.dragStart = false
    },
    handleDragOver (event) {
      event.preventDefault()
    },
    handleDrop (event) {
      this.dragEnter = false
      this.emitMove({ from: this.dragItemId, to: this.unitId })
    },
    initializeDragDrop () {
      let dragItem = this.$el.getElementsByClassName('form__orgunits_item_block_box_top_left_dragdrop_button')
      let dragCover = this.$el.getElementsByClassName('form__orgunits_item_block_dragcover')

      if (dragItem.length) {
        dragItem = dragItem[0]
        dragItem.addEventListener('dragstart', this.handleDragStart)
        dragItem.addEventListener('dragend', this.handleDragEnd)
      }
      if (dragCover.length) {
        dragCover = dragCover[0]
        dragCover.addEventListener('dragenter', () => this.handleDragEnter(event))
        dragCover.addEventListener('dragleave', this.handleDragLeave)
        dragCover.addEventListener('dragover', this.handleDragOver)
        dragCover.addEventListener('drop', () => this.handleDrop(event))
      }
    },
    initializeAddDragEnterListener () {
      this.$eventBus.$on('form-org-units-disable-dragenter', () => {
        this.dragEnter = false
      })
    },
    initializeRemoveDragEnterListener () {
      this.$eventBus.$off('form-org-units-disable-dragenter')
    },
    initializeAddOpenCloseListeners () {
      this.$eventBus.$on('form-org-units-open-all-groups', this.enableMainBox)
      this.$eventBus.$on('form-org-units-close-all-groups', this.disableMainBox)
      this.$eventBus.$on('form-org-units-open-specific-group', this.enableMainBox)
      this.$eventBus.$on('form-org-units-close-specific-group', this.disableMainBox)
    },
    initializeRemoveOpenCloseListeners () {
      this.$eventBus.$off('form-org-units-open-all-groups', this.enableMainBox)
      this.$eventBus.$off('form-org-units-close-all-groups', this.disableMainBox)
      this.$eventBus.$off('form-org-units-open-specific-group', this.enableMainBox)
      this.$eventBus.$off('form-org-units-close-specific-group', this.disableMainBox)
    }
  },
  mounted () {
    this.initializeAddOpenCloseListeners()
    this.initializeAddDragEnterListener()
    this.initializeEditableFields()
    this.initializeDragDrop()
  },
  updated () {
    this.initializeEditableFields()
    this.initializeDragDrop()
    this.initializeRemoveOpenCloseListeners()
    this.initializeRemoveDragEnterListener()
    this.initializeAddOpenCloseListeners()
    this.initializeAddDragEnterListener()
  },
  beforeDestroy () {
    this.initializeRemoveDragEnterListener()
    this.initializeRemoveOpenCloseListeners()
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formorgunitsitem";
</style>
